import { useOloConsumerInfo } from "./useOloConsumerInfo";

export const useOloCreditCards = (storePrettyUrl: string) => {
  return useOloConsumerInfo(storePrettyUrl, {
    select: consumerInfo => consumerInfo.cards,
  });
};
